module.exports = __webpack_public_path__ + "img/73.f9bf89d6.jpg";